import React, {useState, useEffect} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Signout from './components/Signout';
import Dashboard from './pages/Dashboard';
import Index from './pages/Index';
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import Onboard from './pages/Onboard';
import Wallets from './pages/Wallets';
import Wallet from './pages/Wallet';
import Profile from './pages/Profile';
import Transactions from './pages/Transactions';
import Preferences from './pages/Preferences';
import Errors from './pages/Errors';
import "./assets/css/style.css"
import { getUser } from './utils/profile';
import Redirect from './pages/Redirect';

function App() {
  const [profile, setProfile] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
      document.title = 'Pouch | Profile'
      const fetchUser = async () => {
          setIsPending(true)
          let user = await getUser(sessionStorage.getItem('localId'))
          if (!user) {
            setError('Could not fetch user data')
          } else {
            if(user.code === 400) {
              setError(user.message || 'Could not fetch user data')
            } else {
              setProfile(user)
            }
          }
      }
      fetchUser()
      setIsPending(false)
      // eslint-disable-next-line
  }, [])
  
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Index} />
        <Route exact path="/dashboard" render={props => <Dashboard {...props} profile={profile} isPending={isPending} error={error} />} />
        <Route exact path="/welcome" component={Onboard} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/signin" component={Signin} />
        <Route exact path="/signout" component={Signout} />
        <Route exact path="/wallets" render={props => <Wallets {...props} profile={profile} isPending={isPending} error={error} />} />
        <Route exact path="/wallet" render={props => <Wallet {...props} profile={profile} isPending={isPending} error={error} />} />
        <Route exact path="/profile" render={props => <Profile {...props} profile={profile} isPending={isPending} error={error} />} />
        <Route exact path="/transactions" render={props => <Transactions {...props} profile={profile} isPending={isPending} error={error} />} />
        <Route exact path="/preferences" render={props => <Preferences {...props} profile={profile} isPending={isPending} error={error} />} />
        <Route exact path="/redirect" component={Redirect} />
        <Route exact path="*" component={Errors} />
      </Switch>
      {sessionStorage.getItem('idToken') && <><br></br> <br></br> <br></br></>}
    </BrowserRouter>
  );
}

export default App;
